import React from 'react';
import { MenuItem, ListItemIcon } from "@material-ui/core";
import { ExitToApp } from '@material-ui/icons';
import Cookies from "universal-cookie";
import { removeAuthCookie } from "../../config/config";
const cookies = new Cookies();

export default function AuthComponent() {

  // logout
  const logout = () => {
    // destroy the cookie
    removeAuthCookie(cookies, "token");
    removeAuthCookie(cookies, "user");
    // redirect user to the landing page
    window.location.href = "/";
  };

  return (
    <>
      <MenuItem onClick={() => logout()}>
          <ListItemIcon>
            <ExitToApp fontSize="small" />
          </ListItemIcon>
          Salir
        </MenuItem>
    </>
  );
}
